import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import ACCOUNT_CLIENT_API_ENDPOINTS from '@api/endpoints';
import HTTP_METHODS_ENUM from '@api/enums/HTTP_METHODS_ENUM.enum';
import httpClient from '@api/httpClient';

import CurrentUserBranch from './interfaces/CurrentUserBranch.interface';

export interface BranchesResponse {
	branches: CurrentUserBranch[];
}

const getBranches = createAsyncThunk<CurrentUserBranch[], { accessToken: string }, { rejectValue: AxiosError }>(
	ACCOUNT_CLIENT_API_ENDPOINTS.AUTH.USER_BRANCHES(),
	async (accessToken, { rejectWithValue }) => {
		try {
			const branchesResponse = await httpClient.request<BranchesResponse>({
				url: ACCOUNT_CLIENT_API_ENDPOINTS.AUTH.USER_BRANCHES(),
				data: { with: ['forms.translations'] },
				headers: { Authorization: `Bearer ${accessToken}` },
				method: HTTP_METHODS_ENUM.POST,
			});
			return branchesResponse.data.branches;
		} catch (e: unknown) {
			return rejectWithValue(e as AxiosError);
		}
	},
);

export default getBranches;
